import type { RouteLocationRaw } from 'vue-router'
import type { CampaignListItem } from '../resources'

export type CampaignStart = 'empty' | 'brief'

export const campaignIsDraft = (campaign: Pick<CampaignListItem, 'briefSignedOffAt' | 'postsTotal' | 'conceptsTotal'>) =>
  campaign.briefSignedOffAt === null && campaign.postsTotal === 0 && campaign.conceptsTotal === 0

export const campaignHasDeliverables = (campaign: Pick<CampaignListItem, 'postsTotal'>) => campaign.postsTotal > 0

export const campaignRoute = (campaign: Pick<CampaignListItem, 'id'>, organizationId: string): RouteLocationRaw => ({
  name: 'campaign',
  params: { organizationId, campaignId: campaign.id }
})
